'use strict';
var getWindow = require('./isWindow');

module.exports = function scrollTop(node, val) {
  var win = getWindow(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
};


//////////////////
// WEBPACK FOOTER
// ../~/gatsby/~/react-router-scroll/~/scroll-behavior/~/dom-helpers/query/scrollTop.js
// module id = 242
// module chunks = 0